export enum LayoutType {
    DESKTOP = 'DESKTOP',
    TABLET = 'TABLET',
    MOBILE = 'MOBILE',
}

export enum LayoutElementType {
    WIDGET = 'WIDGET',
    ANALYSIS = 'ANALYSIS',
}

export type ConstraintsPerLayoutElement = {
    type: LayoutType;
    minWidth: number;
    minHeight: number;
    maxWidth: number;
    maxHeight: number;
};

export type LayoutElement = {
    id: string;
    position: { x: number; y: number };
    type: LayoutElementType;
    size: { width: number; height: number };
    constraints: {
        minWidth: number;
        maxWidth: number;
        minHeight: number;
        maxHeight: number;
    };
};

export default class Layout {
    constructor(readonly type: LayoutType, readonly widgets: LayoutElement[]) {
        if (type === undefined) {
            throw new ReferenceError('Undefined prop');
        }
    }
}
